import React, { Component } from 'react'
import Dialog from 'react-modal'
import { connect } from 'react-redux'
import ModalChangedUnit from './../../../components/Modal/ChangedUnit'
import request from './../../../utils/requestConfig'

const mapStateToProps = ({ units }) => ({
  unit: units.unit.item
})

class ModalSendProductDetailContainer extends Component {
  changeNameUnit = (name) => {
    request.put(`/units/${this.props.unit.id}`, {
      suggested_name: name
    })
      .then(() => this.props.handleCloseModal())
  }
  render () {
    return (
      <Dialog
        isOpen={this.props.isOpenModal}
        contentLabel='Modal'
        onRequestClose={this.props.handleCloseModal}
        className='dialog dialog--modal'>
        <ModalChangedUnit
          handleCloseModal={this.props.handleCloseModal}
          unit={this.props.unit}
          changeNameUnit={this.changeNameUnit}
        />
      </Dialog>
    )
  }
}

export default connect(mapStateToProps, null)(ModalSendProductDetailContainer)



// WEBPACK FOOTER //
// ./src/containers/Modal/ChangedUnit/index.js